<template>
  <el-select-v2
    v-model="model"
    filterable
    :options="options"
    :remote="remote"
    :remote-method="remoteMethod"
    :loading="loading"
    :multiple="multiple"
    :props="{ value: 'id', label: 'name' }"
    :placeholder="placeholder"
    :disabled="disabled"
    :clearable="clearable"
    class="my-select"
    @change="emit('change', $event)"
  >
    <template #default="{ item }">
      <span :title="item.name">{{ item.name }}</span>
    </template>
  </el-select-v2>
</template>

<script setup>
const emit = defineEmits(['change'])
defineProps({
  options: Array,
  multiple: {
    type: Boolean,
    default: false
  },
  placeholder: {
    type: String,
    default: '请选择'
  },
  remote: {
    type: Boolean,
    default: false
  },
  remoteMethod: {
    type: Function,
    default: null
  },
  loading: {
    type: Boolean,
    default: false
  },
  clearable: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  }
})
const model = defineModel()
</script>
